/* eslint-disable max-lines */
import React, { Component, createRef } from 'react';
import { connect } from 'react-redux';
import { CircularProgress, withStyles } from '@material-ui/core';
import AppointmentList from './List/List';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import {
    reorderAppointment,
    changeStateOfAppointment,
    toggleForceReload,
    setSelectedAppointment
} from '../../redux/Appointment/AppointmentAction';
import { DragDropContext } from 'react-beautiful-dnd';
import moment from 'moment-jalaali';
import { MainDialog } from '../UI';
import AdmissionForm from '../Admission/AdmissionForm';
import { messages } from '../../lang/en';
import { createLoadingSelector } from '../../redux/Loading/LoadingSelector';
import * as type from '../../redux/Appointment/AppointmentType';

const styles = {
    container: {
        width: '100%',
        // height: "100%",
        // overflow: 'auto',
        padding: '40px',
        backgroundColor: '#f2f4fa',
        direction: 'rtl',
        textAlign: 'right'
    },
    mainContainer: {
        paddingTop: '51px'
        // height: 'calc(100vh - 90px)',
    },
    appointmentContainer: {
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr 1fr',
        gridGap: '20px',
        position: 'relative',
        // minHeight: "100%",
        height: 'calc(100vh - 178px)'
    },
    loadingContainer: {
        position: 'absolute',
        top: '0',
        left: '0',
        right: '0',
        bottom: '0',
        '& > div': {
            width: '100%',
            height: '100%',
            maxHeight: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
        }
    },
    progress: {
        color: '#063f5e'
    }
};

class Appointment extends Component {
    sensorAPIRef = createRef();
    constructor(props) {
        super(props);
        this.state = {
            appointments: {
                appointed: [],
                admitted: [],
                entered: [],
                exited: []
            },
            appointmentStates: {
                appointed: { label: 'appointments', id: 'appointed', index: 0 },
                admitted: { label: 'waitingRoom', id: 'admitted', index: 1 },
                entered: { label: 'inside', id: 'entered', index: 2 },
                exited: { label: 'visited', id: 'exited', index: 3 }
            },
            allAppointments: [],
            dragging: {
                source: null,
                destination: null
            },
            selectedAppointment: null,
            sourceState: null,
            destinationState: 'admitted',
            openAdmissionDialog: false
        };
    }
    componentDidUpdate(props) {
        if (props.forceReload) {
            props.toggleForceReload(false);
        }
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        let newAppointments = {};
        let differ = false;
        const length = nextProps.appointments?.length;
        if (prevState.allAppointments?.length !== length) {
            differ = true;
        } else {
            for (let i = 0; i < length; i++) {
                if (
                    prevState.allAppointments[i]?.id !== nextProps.appointments?.[i]?.id ||
                    prevState.allAppointments[i]?.state !== nextProps.appointments?.[i]?.state ||
                    prevState.allAppointments[i]?.order !== nextProps.appointments?.[i]?.order
                ) {
                    differ = true;
                    break;
                }
            }
        }
        if (nextProps.forceReload) {
            differ = true;
        }
        if (differ) {
            for (let state in prevState.appointments) {
                newAppointments = {
                    ...newAppointments,
                    [state]: nextProps.appointments
                        ?.filter((val) => val.state === state)
                        ?.sort((a, b) => a?.order - b?.order)
                };
            }
            return {
                allAppointments: nextProps.appointments,
                appointments: newAppointments
            };
        } else {
            return null;
        }
    }
    handleDragEnd(dragResult) {
        this.setState((prevState) => {
            return {
                dragging: {
                    ...prevState.dragging,
                    source: null
                }
            };
        });
        const { destination, source, draggableId } = dragResult;
        // drop out of list
        if (!destination) {
            return;
        }

        if (source.droppableId === destination.droppableId && source.index === destination.index) {
            return;
        } else {
            if (source.droppableId === destination.droppableId) {
                this.reorderPatientList(
                    source.index,
                    destination.index,
                    source.droppableId,
                    draggableId
                );
            } else {
                this.changeStateOfAppointment(
                    draggableId,
                    source.index,
                    destination.index,
                    source.droppableId,
                    destination.droppableId
                );
            }
        }
    }
    changeStateOfAppointment(draggableId, sourceIndex, destinationIndex, sourceState, targetState) {
        const { appointments, appointmentStates } = this.state;
        const sourceStateIndex = appointmentStates[sourceState].index;
        const destinationStateIndex = appointmentStates[targetState].index;
        const destinationPatients = appointments?.[targetState];
        const sourcePatients = appointments?.[sourceState];
        let draggedItem = sourcePatients?.find(
            (val) => val?.id.toString() === draggableId.toString()
        );
        this.props.setSelectedAppointment(draggedItem);
        this.setState({
            selectedAppointment: draggedItem,
            sourceState: sourceState,
            destinationState: targetState
        });
        // handle not yet admitted appointment
        if (draggedItem?.state === 'appointed') {
            this.setState({ openAdmissionDialog: true });
            return;
        }
        draggedItem = { ...draggedItem, state: targetState };

        let targetIndex = -1;
        let reverseOrder;
        if (+sourceStateIndex > +destinationStateIndex) {
            targetIndex = 0;
            reverseOrder = true;
            Object.keys(appointmentStates).forEach((val) => {
                if (+appointmentStates[val]?.index > +destinationStateIndex) {
                    draggedItem = {
                        ...draggedItem,
                        [val]: null
                    };
                }
            });
        } else {
            Object.keys(appointmentStates).forEach((val) => {
                if (
                    +appointmentStates[val]?.index > +sourceStateIndex &&
                    +appointmentStates[val]?.index <= +destinationStateIndex
                ) {
                    draggedItem = {
                        ...draggedItem,
                        [val]: new Date().toString()
                    };
                }
            });
        }

        let newDestinationArray = Array.from(destinationPatients);
        let newSourceArray = Array.from(sourcePatients);
        newSourceArray.splice(sourceIndex, 1);
        newDestinationArray.splice(targetIndex, 0, draggedItem);
        this.setState(
            (prevState) => {
                return {
                    ...prevState,
                    appointments: {
                        ...prevState.appointments,
                        [targetState]: newDestinationArray,
                        [sourceState]: newSourceArray
                    }
                };
            },
            () => {
                if (destinationPatients.length > 0) {
                    this.liftCard(
                        draggableId,
                        newDestinationArray.length,
                        reverseOrder,
                        destinationIndex
                    );
                }
            }
        );
        this.handleChangeStateOfAdmittedAppointment(
            draggedItem?.id,
            sourceStateIndex,
            destinationStateIndex,
            sourceState,
            targetState
        );
    }
    async handleChangeStateOfAdmittedAppointment(
        appointmentId,
        sourceStateIndex,
        destinationStateIndex,
        sourceState,
        targetState
    ) {
        const response = await this.props.changeStateOfAppointment(
            appointmentId,
            targetState,
            +sourceStateIndex < +destinationStateIndex ? 'last' : 'first'
        );
        if (!response || response?.status !== 200) {
            this.revertAppointmentState(this.state.selectedAppointment, sourceState, targetState);
        }
    }
    removeAppointmentFromState(appointmentId, state) {
        const appointments = this.state?.appointments?.[state];
        const filteredArray = appointments?.filter((val) => val.id !== appointmentId);
        this.setState((prevState) => {
            return {
                appointments: {
                    ...prevState.appointments,
                    [state]: filteredArray
                }
            };
        });
    }
    addAppointmentToState(appointment, state) {
        const appointments = this.state.appointments?.[state];
        const newAppointment = { ...appointment, state: state };
        const newArray = [...appointments, newAppointment];
        this.setState((prevState) => {
            return { appointments: { ...prevState.appointments, [state]: newArray } };
        });
    }
    revertAppointmentState(appointment, sourceState, destState) {
        this.removeAppointmentFromState(appointment.id, destState);
        this.addAppointmentToState(appointment, sourceState);
    }
    async reorderPatientList(sourceIndex, destinationIndex, state, draggableId) {
        const appointments = this.state?.appointments?.[state];
        let draggedItem = appointments?.find(
            (val) => val?.id.toString() === draggableId.toString()
        );
        let newArray = Array.from(appointments);
        newArray.splice(sourceIndex, 1);
        newArray.splice(destinationIndex, 0, draggedItem);
        this.setState((prevState) => {
            return {
                ...prevState,
                appointments: {
                    ...prevState.appointments,
                    [state]: newArray
                }
            };
        });

        let position = null;
        if (destinationIndex === 0) {
            position = 'first';
        } else if (destinationIndex === appointments?.length - 1) {
            position = 'last';
        }
        const prevId = appointments?.[destinationIndex - 1]?.id;
        const response = await this.props.reorderAppointment(draggableId, position, prevId);
        if (!response || response.status !== 200) {
            this.setState((prevState) => {
                return {
                    ...prevState,
                    appointments: {
                        ...prevState.appointments,
                        [state]: appointments
                    }
                };
            });
        }
    }
    handleDragStart(result) {
        const { droppableId } = result.source;
        this.setState((prevState) => {
            return {
                dragging: {
                    ...prevState.dragging,
                    source: droppableId
                }
            };
        });
    }
    useSensor = (api) => {
        this.sensorAPIRef.current = api;
    };
    liftCard(cardId, targetLength, reverseOrder, destinationIndex) {
        if (this.state.isDragging) {
            return;
        }
        if (!this.sensorAPIRef.current) {
            console.log('unable to find sensor api');
            return;
        }
        const preDrag = this.sensorAPIRef.current.tryGetLock(cardId);
        if (!preDrag) {
            console.log('unable to start capturing');
            return;
        }
        const completed = preDrag.snapLift();
        if (reverseOrder) {
            if (destinationIndex !== 0) {
                for (let i = 0; i < targetLength; i++) {
                    completed.moveUp();
                }
            }
        } else {
            for (let i = 0; i < targetLength; i++) {
                completed.moveDown();
            }
        }

        completed.drop();
    }
    handleCloseDialog = () => {
        this.setState({ openAdmissionDialog: false });
    };
    handleAdmittedAppointment = (appointment) => {
        if (this.props.socketCondition !== 'CONNECTED') {
            this.addAppointmentToState(appointment, appointment?.state);
            this.removeAppointmentFromState(appointment.id, this.state.sourceState);
        }
        this.setState({ openAdmissionDialog: false });
    };
    render() {
        const { classes, isAppointmentInPatients = false } = this.props;
        const { appointments, dragging, appointmentStates } = this.state;

        return (
            <>
                <div className={classes.mainContainer}>
                    <DragDropContext
                        onDragEnd={(dragResult) => this.handleDragEnd(dragResult)}
                        onDragStart={(dragResult) => this.handleDragStart(dragResult)}
                        sensors={[this.useSensor]}
                    >
                        <div className={classes.appointmentContainer}>
                            {Object.keys(appointmentStates).map((state) => (
                                <div
                                    key={appointmentStates[state].id}
                                    className={classes.appointmentList}
                                >
                                    {this.props.appointmentsData === null && this.props.loading && (
                                        <div className={classes.loadingContainer}>
                                            <div>
                                                <CircularProgress
                                                    classes={{ colorPrimary: classes.progress }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {/* {appointments?.[state] && ( */}
                                    <AppointmentList
                                        isAppointmentInPatients={isAppointmentInPatients}
                                        draggingSource={dragging.source}
                                        section={appointmentStates[state]}
                                        appointments={appointments?.[state]}
                                    />
                                    {/* )} */}
                                </div>
                            ))}
                        </div>
                    </DragDropContext>
                    {this.state.openAdmissionDialog && (
                        <MainDialog
                            open={true}
                            title={messages.admission}
                            goBack={this.handleCloseDialog}
                        >
                            <AdmissionForm
                                handleStateChange={this.handleAdmittedAppointment}
                                destinationState={this.state.destinationState}
                            />
                        </MainDialog>
                    )}
                </div>
            </>
        );
    }
}
Appointment.propTypes = {
    appointments: PropTypes.array,
    classes: PropTypes.object,
    polyclinics: PropTypes.array,
    loading: PropTypes.bool,
    reorderAppointment: PropTypes.func,
    changeStateOfAppointment: PropTypes.func,
    toggleForceReload: PropTypes.func,
    forceReload: PropTypes.bool,
    socketCondition: PropTypes.string,
    setSelectedAppointment: PropTypes.func,
    isAppointmentInPatients: PropTypes.bool,
    appointmentsData: PropTypes.array
};
const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            reorderAppointment,
            changeStateOfAppointment,
            toggleForceReload,
            setSelectedAppointment
        },
        dispatch
    );

const mapStateToProps = (state) => {
    return {
        appointmentsData: state.appointment?.appointments,
        forceReload: state.appointment.forceReload,
        appointments: state.appointment?.appointments?.filter(
            (val) =>
                moment(val.appointed).format('YYYY-MM-DD') === state.appointment?.date?.selected
        ),
        loading: createLoadingSelector(type.GET_APPOINTMENTS.REQUEST),
        socketCondition: state.general.socketCondition
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Appointment));
